import { createAction } from '@reduxjs/toolkit';
import { asyncActionCreator } from '../../global/redux';
import * as constants from './constants';

export const postLoginUser = asyncActionCreator(constants.POST_LOGIN_USER);
export const logout = createAction(constants.LOGOUT);
export const postRefreshUser = asyncActionCreator(constants.POST_REFRESH_USER);

export default postLoginUser;
